import { Grid, Typography } from "@mui/material";
import { useFieldArray } from "react-hook-form";

import { useTranslation } from "react-i18next";

import {
  AutoComplete,
  FormArray,
  FormInput,
  ISelectType,
  useFormContext,
} from "@4uhub/lib4uhub";
import { memo } from "react";
import MainApi from "../../../../services/mainApi.service";
import { TUserForm } from "./UserSchema";

const GENERIC_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Generic/";
const genericService = new MainApi<ISelectType>(GENERIC_ROUTE);

export const UserIntegrationData = memo(() => {
  const { control, formState } = useFormContext<TUserForm>();
  const { t } = useTranslation();

  const documentsFieldArray = useFieldArray<TUserForm>({
    control,
    name: "userIntegrations",
  });

  return (
    <Grid item xs={12}>
      <FormArray
        title={t("page.register.users.user_integration")}
        name="userIntegrations"
        addButtonLabel={
          t("page.register.users.add_new_integration") || "Add new item"
        }
        formArray={documentsFieldArray}
        appendValue={{
          userIntegrationType: null,
          integration: "",
        }}
        fieldsObject={(index) => {
          const userIntegrationType = `userIntegrations.${index}.userIntegrationType`;
          const integration = `userIntegrations.${index}.integration`;

          return (
            <>
              <Grid item xs={12} sm={6}>
                <AutoComplete
                  params={{ identifier: "UserIntegrationType" }}
                  getOptionLabel={(option) => option.name}
                  size="small"
                  label={t("page.register.users.user_integration_type")}
                  name={userIntegrationType}
                  request={genericService.list}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormInput
                  size="small"
                  name={integration}
                  label={t("page.register.users.integration") || "Price"}
                  fullWidth
                />
              </Grid>
            </>
          );
        }}
      />
      {formState.errors.userIntegrations && (
        <Typography variant="body2" color={"error"}>
          {formState.errors.userIntegrations.message
            ? t(`${formState.errors.userIntegrations.message}`)
            : formState.errors.userIntegrations.root?.message
            ? t(`${formState.errors.userIntegrations.root?.message}`)
            : null}
        </Typography>
      )}
    </Grid>
  );
});
